import React from 'react';

import { BodyLargeText, Column, H3, Ul } from 'playful-ui';

export const Module2 = () => (
  <React.Fragment>
  <Column style={{ maxWidth: '754px' }} className="left">
    <H3 style={{ textAlign: 'center', alignSelf: 'center', marginTop: '32px' }}>
      Izrada Mobilne Aplikacije s Glasovnim Naredbama
    </H3>
    <BodyLargeText>
      Isprogramiraj robota i mobilnu aplikaciju da sluša glasovne naredbe kao što su "pleši" i
      "kreni naprijed".
    </BodyLargeText>
    <Ul style={{ marginLeft: '48px' }}>
      <li>Uvod: Govorne naredbe u robotici</li>
      <li><b>Blokovsko programiranje</b> mobilne aplikacije u MIT App Inventoru</li>
      <li><b>Prepoznavanje govora</b> putem Google speach-to-txt usluge</li>
      <li>Upravljanje STEMI robota putem govornih naredbi</li>
      <li>Izvještaj</li>
    </Ul>
    <BodyLargeText>
      Rezultat: <b>Doma nosiš vlastitu aplikaciju koja sluša tvoje govorne naredbe!</b>
    </BodyLargeText>

    <H3 style={{ textAlign: 'center', alignSelf: 'center', marginTop: '48px' }}>
      3D Modeliranje v2
    </H3>
    <BodyLargeText>
      Napravi korak dalje u svijetu 3D modeliranja te izradi svoj napredni model.
    </BodyLargeText>
    <Ul style={{ marginLeft: '48px' }}>
      <li>Uvod: 3D modeliranje u mehanici</li>
      <li><b>3D modeliranje</b> u programu Fusion 360</li>
      <li><b>Osmišljanje i dizajn</b> vlastitog modela</li>
      <li>Priprema za <b>3D print</b> u programu Cura</li>
      <li><b>Izrada</b> osmišljenog 3D modela -  3D print</li>
      <li>Izvještaj</li>
    </Ul>
    <BodyLargeText>
      Rezultat: <b>Doma nosiš 3D figuru koju si sam osmislio, dizajnirao te isprintao. Pohvali se
      roditeljima i frendovima!</b>
    </BodyLargeText>

    <H3 style={{ marginTop: '64px' }}>Detalji</H3>
    <BodyLargeText>
      <b>Termini</b>: Termini će biti objavljeni tijekom studenog. 😊
    </BodyLargeText>
  </Column>
</React.Fragment>
);
